import { httpGetWithCache } from '@src/service/lib/caching'
import { newGetFunction } from '@src/service/lib/types'
import { whenAccessDenied } from '@src/service/lib/utility'
import { resolveUrlPath } from '@components/navigation'
import { HttpClient } from '@src/service'
import {
  OrganizationUrlProps,
  googleDriveAuthUrl,
  googleDriveStatusUrl,
  googleDriveFoldersUrl,
  googleDriveSyncHistoryUrl
} from './urls'
import {
  GoogleDriveAuthUrlResponse,
  GoogleDriveStatusResponse,
  GoogleDriveFoldersResponse,
  GoogleDriveSyncHistoryResponse
} from './responses'

export const getGoogleDriveAuthUrl = newGetFunction<OrganizationUrlProps, GoogleDriveAuthUrlResponse>(googleDriveAuthUrl)
export const getGoogleDriveStatus = newGetFunction<OrganizationUrlProps, GoogleDriveStatusResponse>(googleDriveStatusUrl)
export const getGoogleDriveFolders = (httpClient: HttpClient) => async (urlProps: OrganizationUrlProps & { parentId?: string }) => {
  const basePath = resolveUrlPath(googleDriveFoldersUrl, urlProps)
  const path = urlProps.parentId ? `${basePath}?parentId=${encodeURIComponent(urlProps.parentId)}` : basePath
  return whenAccessDenied(await httpGetWithCache<GoogleDriveFoldersResponse>(httpClient, path))
}
export const getGoogleDriveSyncHistory = newGetFunction<OrganizationUrlProps, GoogleDriveSyncHistoryResponse>(googleDriveSyncHistoryUrl)
